import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { forkJoin, of } from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { TeamSquadService } from '../../services/team-squad.service';

interface AssignmentState {
  loading: boolean;
  isResponsible: boolean;
  isCoordinator: boolean;
}

const NOT_ASSIGNED: AssignmentState = {
  loading: false,
  isResponsible: false,
  isCoordinator: false,
};

const LOADING: AssignmentState = { ...NOT_ASSIGNED, loading: true };

@Component({
  selector: 'mihmo-customer-assignment-badges',
  standalone: true,
  templateUrl: './customer-assignment-badges.component.html',
  styleUrls: ['./customer-assignment-badges.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerAssignmentBadgesComponent {
  private teamSquadService = inject(TeamSquadService);

  customerId = input.required<string>();

  // Erro em uma das chamadas não pode esconder o badge da outra.
  readonly state = toSignal(
    toObservable(this.customerId).pipe(
      switchMap((customerId) =>
        customerId
          ? forkJoin({
              isResponsible: this.teamSquadService
                .checkResponsible(customerId)
                .pipe(
                  map((res) => !!res?.isResponsible),
                  catchError(() => of(false)),
                ),
              isCoordinator: this.teamSquadService
                .checkCoordinator(customerId)
                .pipe(
                  map((res) => !!res?.isCoordinator),
                  catchError(() => of(false)),
                ),
            }).pipe(
              map((res) => ({ loading: false, ...res })),
              startWith(LOADING),
            )
          : of(NOT_ASSIGNED),
      ),
    ),
    { initialValue: LOADING },
  );
}
